import axios from 'axios';
import qs from 'qs';
import {
  hostUrl
} from './util'

axios.defaults.baseURL = hostUrl;

axios.interceptors.request.use(function (config) {

  if (config.headers['Content-Type'] !== 'multipart/form-data') {
    
    config.transformRequest = [function (data) {
      
      return qs.stringify(data)
    }]
  }



  return config;
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  
  
  
  return response.data
}, function (error) {
  return Promise.reject(error);
})

export default axios;